import { Priority } from 'kbar';

import { Icons } from '@/assets/icons/icons';
import { ModalsManager } from '@/components/modals/modalsManager';
import { createAction } from '@/features/cmd-bar/actions';

import { CreateProjectModal } from './create-project-modal';

export const startNewProjectChat = createAction({
  id: 'start-new-project',
  name: 'New Project',
  section: 'Actions',
  keywords: 'project create',
  icon: <Icons.folderPlus size={14} />,
  perform: () => {
    ModalsManager.show(CreateProjectModal);
  },
  priority: Priority.HIGH,
});

export const projectActions = [startNewProjectChat];
